import PwaInstallController from "./pwa_install_controller"
import { Application } from "@hotwired/stimulus"
import EditionFormatController from "./edition_format_controller"
import FastFlipController from "./fast_flip_controller"
import EpubReaderController from "./epub_reader_controller"
import PdfReaderController from "./pdf_reader_controller"
import PdfReadingMigrationController from "./pdf_reading_migration_controller"
import ReadingTimeController from "./reading_time_controller"
import ReadingMigrationController from "./reading_migration_controller"
import UserMergeAnnotationsController from "./user_merge_annotations_controller"
import AvatarController from "./avatar_controller"
import FlashController from "./flash_controller"
import OfflinePdfController from "./offline_pdf_controller"
import OfflineSessionController from "./offline_session_controller"
import OfflineLibraryController from "./offline_library_controller"
import ProcessingStatusController from "./processing_status_controller"
import CouponAccessController from "./coupon_access_controller"
import TomSelectController from "./tom_select_controller"
import FilterPanelController from "./filter_panel_controller"
import CatalogSearchController from "./catalog_search_controller"
import ClipboardController from "./clipboard_controller"
import AutoSubmitController from "./auto_submit_controller"
import CatalogSliderController from "./catalog_slider_controller"
import GiftDeliveryStatusController from "./gift_delivery_status_controller"
import CheckoutStatusController from "./checkout_status_controller"
import FormSubmitController from "./form_submit_controller"
import HostedBillingNavigationController from "./hosted_billing_navigation_controller"
import LoginMethodController from "./login_method_controller"
import SubscriptionPlanController from "./subscription_plan_controller"
import PricingDialogController from "./pricing_dialog_controller"
import UiDialogController from "./ui_dialog_controller"

window.Stimulus = Application.start()
Stimulus.register("edition-format", EditionFormatController)
Stimulus.register("fast-flip", FastFlipController)
Stimulus.register("ebooks-reader", EpubReaderController)
Stimulus.register("pdf-reader", PdfReaderController)
Stimulus.register("pdf-reading-migration", PdfReadingMigrationController)
Stimulus.register("reading-time", ReadingTimeController)
Stimulus.register("reading-migration", ReadingMigrationController)
Stimulus.register("user-merge-annotations", UserMergeAnnotationsController)
Stimulus.register("avatar", AvatarController)
Stimulus.register("flash", FlashController)
Stimulus.register("offline-pdf", OfflinePdfController)
Stimulus.register("offline-session", OfflineSessionController)
Stimulus.register("offline-library", OfflineLibraryController)
Stimulus.register("processing-status", ProcessingStatusController)
Stimulus.register("coupon-access", CouponAccessController)
Stimulus.register("tom-select", TomSelectController)
Stimulus.register("filter-panel", FilterPanelController)
Stimulus.register("catalog-search", CatalogSearchController)
Stimulus.register("clipboard", ClipboardController)
Stimulus.register("auto-submit", AutoSubmitController)
Stimulus.register("catalog-slider", CatalogSliderController)
Stimulus.register("checkout-status", CheckoutStatusController)
Stimulus.register("form-submit", FormSubmitController)
Stimulus.register("hosted-billing-navigation", HostedBillingNavigationController)
Stimulus.register("login-method", LoginMethodController)
Stimulus.register("subscription-plan", SubscriptionPlanController)
Stimulus.register("pricing-dialog", PricingDialogController)
Stimulus.register("ui-dialog", UiDialogController)

Stimulus.register("gift-delivery-status", GiftDeliveryStatusController)

Stimulus.register("pwa-install", PwaInstallController)
